import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, HostListener, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import {
  ApiService,
  ObservalbeStateService,
  UtilityService,
} from "../../service";
import { UsersService } from "../../service/user.service";

@Component({
  selector: "app-main-header",
  templateUrl: "./main-header.component.html",
  styleUrls: ["./main-header.component.scss"],
})
export class MainHeaderComponent implements OnInit {
  public navbarCollapsed = true;
  langArr: any;
  selectedLang: any;
  profile: any;
  totalRoleList: any;
  profileRoleName: any;
  menuList: any;
  getFromPage: string;
  pwdFlag: string;
  statusMsg: any = {};
  USM001: any;
  MAS001: any;
  isMobile: boolean;
  menuData: any;
  userInfo: any;
  getserverTime: any;
  constructor(
    public api: ApiService,
    public utility: UtilityService,
    public router: Router,
    public userService: UsersService,
    public observable: ObservalbeStateService,
    public http: HttpClient
  ) {
    this.detectScreenSize();
  }

  @HostListener("window:resize")
  onResize() {
    this.detectScreenSize();
  }

  detectScreenSize() {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem("vprpinfo"));
    this.getFromPage = localStorage.getItem(`fromPage`);
    this.pwdFlag = localStorage.getItem(`pwdresetflags`);
    this.getLanguage();
    const lang: any = localStorage.getItem(`selectedLang`);
    let selLang = JSON.parse(lang);
    this.selectedLang = lang ? selLang.lang_name : "English";
    this.getRoleList();
    const prof = localStorage.getItem(`vprpinfo`);
    this.profile = JSON.parse(prof);
  }

  onInput() {
    var browser: any = document.getElementById("browser");
    var opts: any = document.getElementById("browsers").childNodes;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].value === browser.value) {
        browser.placeholder = `Search ${opts[i].value} here`;
        browser.value = "";
        break;
      }
    }
    return opts;
  }

  getLanguage() {
    const reqHeader = {
      _user_code: this.userInfo.loginId,
      _user_token: "",
      _url: "/getLanguages",
      _succ_msg: "",
    };
    this.http
      .post(
        `${environment.endpoint}/${"iudUsertoken"}`,
        JSON.stringify(reqHeader),
        { headers: this.iudgetHeaders("/iudUsertoken") }
      )
      .subscribe(async (res: any) => {
        if (res) {
          this.api
            .get(
              `/getLanguages?screenCode=${`W01LGNCXX`}@${
                res.myArrayList[0].map._user_token
              }`
            )
            .subscribe((res: any) => {
              this.langArr = res;
              setTimeout(() => {
                this.getMenuList();
              }, 1500);
            });
        }
      });
  }

  changeLang(lang?: any) {
    const getSelectedLang = localStorage.getItem(`selectedLang`);
    let alreadySelected = JSON.parse(getSelectedLang);
    this.langArr.forEach(async (element: any) => {
      if (element.lang_code == lang) {
        if (alreadySelected.lang_code != element.lang_code) {
          this.selectedLang = element.lang_name;
          this.utility.selectedLang = element;
          localStorage.setItem("selectedLang", JSON.stringify(element));
          // this.utility.setLanguage(element.lang_code);
          this.getMenuList();
          await this.router.navigateByUrl("/layout/dashboard");
          //await window.location.reload();
        }
      }
    });
  }

  logout() {
    this.http
      .get<any>(`${environment.endpoint}/getdate`, {
        headers: this.iudgetHeaders("/getdate"),
      })
      .subscribe(async (res: any) => {
        this.getserverTime = res.map._date;
        const reqHeader = {
          _user_code: this.userInfo.loginId,
          _user_token: "",
          _url: "/iudusertokenexpired",
          _succ_msg: "",
        };
        this.http
          .post(
            `${environment.endpoint}/${"iudUsertoken"}`,
            JSON.stringify(reqHeader),
            { headers: this.iudgetHeaders("/iudUsertoken") }
          )
          .subscribe(async (res: any) => {
            if (res) {
              const obj = {
                userCode: this.api.encrypt(
                  this.userInfo.loginId,
                  this.getserverTime
                ),
                succmsg: "",
              };
              this.api
                .withOutLang(
                  `/iudusertokenexpired@${res.myArrayList[0].map._user_token}`,
                  obj
                )
                .subscribe((res) => {
                  if (res) {
                    localStorage.clear();
                    sessionStorage.clear();
                    this.router.navigateByUrl("/auth");
                  }
                });
            }
          });
      });
  }

  getMessage() {
    const reqHeader = {
      _user_code: this.userInfo.loginId,
      _user_token: "",
      _url: "/getMessagedesclist",
      _succ_msg: "",
    };
    this.http
      .post(
        `${environment.endpoint}/${"iudUsertoken"}`,
        JSON.stringify(reqHeader),
        { headers: this.iudgetHeaders("/iudUsertoken") }
      )
      .subscribe(async (res: any) => {
        if (res) {
          this.api
            .get(`/getMessagedesclist?@${res.myArrayList[0].map._user_token}`)
            .subscribe(async (res) => {
              const WebMessage = res[0].filter(
                (item) => item.msg_code.charAt(1) == "W"
              );
              await localStorage.setItem(
                `WebMessage`,
                JSON.stringify(WebMessage)
              );
              await localStorage.setItem(
                `ActionMessage`,
                JSON.stringify(
                  res[0].filter((item) => item.msg_code == "AW01GENMSG_023")
                )
              );
              this.userService.getErrorMessage("AW01GENMSG_030").then((res) => {
                this.statusMsg.userId = res;
              });
              this.userService.getErrorMessage("AW01GENMSG_031").then((res) => {
                this.statusMsg.userName = res;
              });
              this.userService.getErrorMessage("AW01GENMSG_032").then((res) => {
                this.statusMsg.email = res;
              });
              this.userService.getErrorMessage("AW01GENMSG_033").then((res) => {
                this.statusMsg.role = res;
              });
            });
        }
      });
  }

  getRoleList() {
    const reqHeader = {
      _user_code: this.userInfo.loginId,
      _user_token: "",
      _url: "/getRolelist",
      _succ_msg: "",
    };
    this.http
      .post(
        `${environment.endpoint}/${"iudUsertoken"}`,
        JSON.stringify(reqHeader),
        { headers: this.iudgetHeaders("/iudUsertoken") }
      )
      .subscribe(async (res: any) => {
        if (res) {
          this.api
            .get(`${"/getRolelist?"}@${res.myArrayList[0].map._user_token}`)
            .subscribe((res: any) => {
              this.totalRoleList = res;
              this.totalRoleList.forEach((element) => {
                if (
                  element.role_code ==
                  this.profile.userRoles[0].applicationRole.roleName
                ) {
                  this.profileRoleName = element.role_name;
                }
              });
            });
          const prof = localStorage.getItem(`vprpinfo`);
          this.profile = JSON.parse(prof);
        }
      });
  }

  getMenuList() {
    const reqHeader = {
      _user_code: this.userInfo.loginId,
      _user_token: "",
      _url: "/getFetMenuList",
      _succ_msg: "",
    };
    this.http
      .post(
        `${environment.endpoint}/${"iudUsertoken"}`,
        JSON.stringify(reqHeader),
        { headers: this.iudgetHeaders("/iudUsertoken") }
      )
      .subscribe(async (res: any) => {
        if (res) {
          this.api
            .get(
              `/getFetMenuList?roleCode=${this.profile.userRoles[0].applicationRole.roleName}@${res.myArrayList[0].map._user_token}`
            )
            .subscribe((res: any) => {
              if (res) {
                this.menuData = res[0].filter(
                  (item) => item.menu_type_code == "L"
                );
                this.menuList = res[0].filter(
                  (item) => item.menu_type_code == "T"
                );
                this.USM001 = res[0].filter(
                  (item) =>
                    item.menu_type_code == "T" && item.parent_code == "USM001"
                );
                this.MAS001 = res[0].filter(
                  (item) =>
                    item.menu_type_code == "T" && item.parent_code == "MAS001"
                );

                this.getMessage();
              }
            });
        }
      });
  }

  getMenuCode(_data: any) {
    this.observable.MenuCode(_data);
    this.router.navigateByUrl(_data.url_action_method);
  }

  iudgetHeaders(url) {
    let headerValue = {};
    const token = localStorage.getItem(`token`);
    headerValue = {
      "Content-Type": "application/json",
      "Content-Security-Policy":
        "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
      "X-Tenant-Identifier": "dynamic_lokos",
      Authorization: token ? "Bearer " + token : "",
      "Cache-Control":
        "no-cache, no-store, must-revalidate, post- check=0, pre-check=0",
      Pragma: "no-cache",
      Expires: "0",
      // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
      // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
      // "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      // "X-XSS-Protection": "1; mode=block",
      _url: url,
      _user_token: "",
      userCode: this.userInfo.loginId,
      roleCode: "",
      blockCode: "",
    };
    return new HttpHeaders(headerValue);
  }
}
